.header {
  display: flex;
  align-items: center;
}

.counter {
  margin-left: 10px;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 10px;
  font-weight: 700;
}

.misalignmentDetails {
  &Root {
    display: flex;
    flex-direction: column;
    gap: 5px;
    font-size: 10px;
    padding: 10px 20px;
    position: relative;

    &::before {
      content: "";
      position: absolute;
      inset: 0;
      box-shadow: inset 0 5px 5px 0 rgb(13 41 118 / 0.5);
      mix-blend-mode: multiply;
      pointer-events: none;
    }
  }

  &Item {
    display: flex;
    flex-direction: column;
  }

  &ItemRow {
    display: flex;
    align-items: center;
    gap: var(--spacingSm);

    > span {
      white-space: nowrap;
    }
  }

  &RoleName {
    font-weight: 700;
  }

  &LinkIcon {
    fill: var(--paletteOrange0);
    cursor: pointer;
  }
}
